/**
 * Mobile premium categories — sidebar tab switching.
 */
class MobileCategoriesPremium {
  /** @param {HTMLElement} root */
  constructor(root) {
    this.root = root;
    this.tabs = root.querySelectorAll('[data-mobile-cat-tab]');
    this.panels = root.querySelectorAll('[data-mobile-cat-panel]');
    this.bind();
  }

  bind() {
    this.tabs.forEach((tab) => {
      const activate = (event) => {
        if (event.type === 'click') {
          event.preventDefault();
          event.stopPropagation();
        }

        const panelId = tab.dataset.mobileCatTab;
        if (!panelId) return;

        this.tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const show = panel.dataset.mobileCatPanel === panelId;
          panel.hidden = !show;
        });
      };

      tab.addEventListener('click', activate);
    });
  }
}

document.querySelectorAll('[data-mobile-categories-premium]').forEach((root) => {
  new MobileCategoriesPremium(root);
});
